import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}
// 查询超市
export function getSuper (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics-supermarket/page-supermarket',
		method: 'post',
		data: obj
	})
}
// 新增超市
export function addSuper (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics-supermarket/insert-supermarket',
		method: 'post',
		data: obj
	})
}
// 修改超市
export function putSuper (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics-supermarket/edit-supermarket',
		method: 'post',
		data: obj
	})
}
// 删除超市
export function delSuper (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics-supermarket/delete-supermarket',
		method: 'post',
		data: obj
	})
}
// 查询超市树
export function getSuperTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/basics-supermarket/supermarket-tree',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 新增商城
export function addShop (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/spm-mall/insert-mall',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 分页查询商城
export function getShop (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/spm-mall/page-mall',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 修改商城
export function putShop (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/spm-mall/edit-mall',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 删除商城
export function delShop (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/spm-mall/delete-mall',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 批量导入商品
export function daoruSuperXlsx (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/batch/import/material-product',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 批量导入原料
export function daoruYuanliaoXlsx (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/menumaterial/batch/import/material',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 分页查询商城商品
export function getShopDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/supermarket-product/page-product',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 批量新增商品到商城
export function addShopDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/supermarket-product/save-batch-product',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 商城商品删除
export function delShopDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/supermarket-product/delete-product',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 修改单一商城商品信息
export function putShopDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/supermarket-product/edit-product',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 获取未被添加到该商城的商品
export function getOtherShopDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/supermarket-product/list-unadd-product',
		method: 'post',
		data: obj,
		mock: false
	})
}
// 保存设备（编辑或新增)
export const addOrEditList = data => {
	return request({
		url: '/api/v1/supermarket/machine/add-or-edit',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 分页获取商超设备
export const getSupermaketList = data => {
	return request({
		url: '/api/v1/supermarket/machine/get-supermaket-device-page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 删除商超设备
export const delSupermaketList = data => {
	return request({
		url: '/api/v1/supermarket/machine/delete-supermaket-device-machine',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 超市报表-超市收入汇总
export const getSuperIncomeList = data => {
	return request({
		url: '/api/v1/markettrade/income/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-商品销售明细
export const getSuperDetailList = data => {
	return request({
		url: '/api/v1/markettrade/goodsdetail/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-设备收收入汇总
export const getSuperMachineList = data => {
	return request({
		url: '/api/v1/markettrade/mchsum/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-超市收入汇总导出
export const exportSuperIncomeList = data => {
	return request({
		url: '/api/v1/markettrade/income/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 超市报表-商品销售明细导出
export const exportSuperDetailList = data => {
	return request({
		url: '/api/v1/markettrade/goodsdetail/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 超市报表-设备收收入汇总导出
export const exportSuperMachineList = data => {
	return request({
		url: '/api/v1/markettrade/mchsum/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 商品销售排行
export const getSuperShopAnalysis = data => {
	return request({
		url: '/api/v1/marketanalysis/goodsrank/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-商品销售排行导出
export const exportSuperShopAnalysis = data => {
	return request({
		url: '/api/v1/marketanalysis/goodsrank/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 按组织收入汇总
export const getSuperOrgsum = data => {
	return request({
		url: '/api/v1/markettrade/orgsum/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-按组织收入汇总导出
export const superOrgsumExport = data => {
	return request({
		url: '/api/v1/markettrade/orgsum/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 按人员类别收入汇总
export const getSuperPsntypesum = data => {
	return request({
		url: '/api/v1/markettrade/psntypesum/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-按人员类别收入汇总导出
export const superPsntypesumExport = data => {
	return request({
		url: '/api/v1/markettrade/psntypesum/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 按人员类别收入汇总
export const getSuperGoodspricechange = data => {
	return request({
		url: '/api/v1/marketanalysis/goodspricechange/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 超市报表-按人员类别收入汇总导出
export const superGoodspricechangeExport = data => {
	return request({
		url: '/api/v1/marketanalysis/goodspricechange/export',
		method: 'post',
		// data,
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 获取商超设备列表
export const getSuperMachineListdevice = data => {
	return request({
		url: '/api/v1/supermarket/machine/list-device',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 预定超市订单状态修改
export const putSuperOrderState = data => {
	return request({
		url: '/api/v2/web/order/goods/update/status',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
